import { z } from "zod/v4";
import { IMPORT_SCRIPT_OPTIONS } from "./ea.enums";
import { ExportToCsvSchema } from "./ea.schema.query";

export const EndpointsSchemas = {
  scripts: {
    clone: {
      request: z.object({
        projectId: z.number(),
        scriptIds: z.array(z.coerce.number()),
        name: z.string().optional(),
        description: z.string().optional(),
      }),
    },
    import: {
      request: z.object({
        projectId: z.coerce.number().optional(),
        globalExcelOption: z.enum(IMPORT_SCRIPT_OPTIONS).optional(),
      }),
    },
  },
  export: {
    generate: ExportToCsvSchema,
  },
};

export const CountResponseSchema = z.object({ count: z.number() });
